//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tabs from '~/components/ui/Tabs'
import GoldPoints from '~/components/gold-points/GoldPoints'
import Faq from '~/components/gold-points/Faq'
import hasWindow from '~/mixins/hasWindow'
import Reward from '~/components/gold-points/Reward'
import Tnc from '~/components/gold-points/Tnc'

export default {
  components: { Tabs, GoldPoints, Faq, Reward, Tnc },
  mixins: [hasWindow],
  data() {
    return {
      tabList: [
        {
          name: 'Rewards',
          icon: '/images/gold-points/reward-icon.svg',
        },
        {
          name: 'GOLD POINT',
          icon: '/images/gold-points/point-icon.svg',
        },
        {
          name: 'FAQ',
          icon: '/images/gold-points/faq-icon.svg',
        },
        {
          name: 'T&C Rewards',
          icon: '/images/gold-points/tnc-icon.svg',
        },
      ],
      input: {},
    }
  },
}
